import { useExperiment } from '@acp/feature/auth';
import { useUserSettings } from './use-user-settings';

function usePortfolioMirroring() {
    const experiments = useExperiment();
    const userSettings = useUserSettings();

    return {
        showSetting: experiments.userExperiments?.AgencyCompliancePortalPortfolioMirroring === true,
        showFeature:
            experiments.userExperiments?.AgencyCompliancePortalPortfolioMirroring === true
            && userSettings.data?.agency.showPortfolioMirroring,
    };
}

export { usePortfolioMirroring };
